export default "__VITE_ASSET__CyYPxBEA__"